// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"f3eaa050","990":"bed70f4b"}[chunkId] + ".chunk.css";
};